import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Care.css";

import Logo from "../images/logo.svg";
import property1 from "../images/property1.png";
import property2 from "../images/property2.png";
import property3 from "../images/property3.png";

const Care_Sale = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("buy");

  const properties = [
    {
      title: "Greenfield Care Home",
      location: "Surrey",
      type: "Residential Care",
      beds: "45 Beds",
      price: "£1,850,000",
      status: "For Sale",
       image: property1,
    },
    {
      title: "Meadow View Care Home",
      location: "Manchester",
      type: "Nursing Care",
      beds: "38 Beds",
      price: "£1,250,000",
      status: "Under Offer",
       image: property2,
    },
    {
      title: "Riverside Care Home",
      location: "Birmingham",
      type: "Residential Care",
      beds: "30 Beds",
      price: "£950,000",
      status: "For Sale",
       image: property3,
    },
  ];

  const salesProcess = [
    {
      number: "01",
      title: "Initial Consultation",
      text: "We understand your objectives, property and ideal transaction before creating a tailored sales strategy.",
    },
    {
      number: "02",
      title: "Valuation & Preparation",
      text: "Our team assesses your care home and prepares the information required to position the opportunity effectively.",
    },
    {
      number: "03",
      title: "Confidential Marketing",
      text: "We present your care home to suitable buyers while maintaining confidentiality throughout the process.",
    },
    {
      number: "04",
      title: "Negotiation",
      text: "We manage enquiries, offers and negotiations to help you achieve the strongest possible outcome.",
    },
    {
      number: "05",
      title: "Due Diligence",
      text: "We support the transaction through due diligence, documentation and communication with relevant parties.",
    },
    {
      number: "06",
      title: "Completion",
      text: "We remain involved through completion to help keep the transaction moving smoothly.",
    },
  ];

  const faqs = [
    {
      question: "How do you value a care home?",
      answer:
        "We consider factors including occupancy, profitability, location, property condition, registered capacity, operational performance and current market conditions.",
    },
    {
      question: "Can you sell my care home confidentially?",
      answer:
        "Yes. Confidentiality is an important part of our approach. We can control how and when information about an opportunity is shared with prospective buyers.",
    },
    {
      question: "Do you help buyers find care homes?",
      answer:
        "Yes. We work with buyers looking for suitable care businesses and properties based on their investment objectives, location and operational requirements.",
    },
    {
      question: "Do you help with due diligence?",
      answer:
        "Yes. We can support you through the transaction process and help coordinate the information required for due diligence.",
    },
  ];

  return (
    <div className="care-sales-page">

        {/* =====================================================
          Main Section
      ====================================================== */}
       <main className="care-sales">

      

        {/* LEFT CONTENT */}
        <div className="care-sales-content">

          <span className="sales-tag">
            EXPERTS IN CARE HOME SALES
          </span>

          <h1>Care homes for sale. <span>Trusted deals.</span>Better outcomes.</h1>

          <p>
            We help care home owners buy, sell and value care homes
            with confidence. From confidential marketing to due
            diligence and negotiation – we manage the process, so
            you get the right result.
          </p>

          {/* BUTTONS */}
          <div className="sales-buttons">

            <button className="primary-sales-btn">
              View Available Homes
            </button>

            <button className="secondary-sales-btn">
              Book a Free Consultation
            </button>

          </div>

          {/* FEATURES */}
          <div className="sales-features">

            <span>
              <b>✓</b> Confidential & Secure
            </span>

            <span>
              <b>✓</b> Expert Valuation
            </span>

            <span>
              <b>✓</b> End-to-End Support
            </span>

          </div>

        </div>

        {/* ================= DASHBOARD ================= */}
        <div className="sales-dashboard">

          <div className="dashboard-header">
            <h3>Care Home Sales Overview</h3>

            <span>
              This Month <small>⌄</small>
            </span>
          </div>

          {/* TOP CARDS */}
          <div className="dashboard-stats">

            <div className="stat-card">
              <strong>28</strong>
              <span>Active Listings</span>
            </div>

            <div className="stat-card">
              <strong>6</strong>
              <span>This Month</span>
            </div>

            <div className="stat-card">
              <strong>7</strong>
              <span>In Progress</span>
            </div>

            <div className="stat-card">
              <strong>12</strong>
              <span>This Month</span>
            </div>

            <div className="stat-card">
              <strong>£1.42M</strong>
              <span>12% vs last month</span>
            </div>

          </div>

          {/* CHART AREA */}
          <div className="dashboard-charts">

            {/* REGION */}
            <div className="chart-box">
              <h4>Properties by Region</h4>

              <div className="donut-wrapper">

                <div className="donut-chart">
                  <div className="donut-inner"></div>
                </div>

                <div className="chart-labels">
                  <span>● South East <b>40%</b></span>
                  <span>● North West <b>20%</b></span>
                  <span>● West Midlands <b>15%</b></span>
                  <span>● Yorkshire <b>15%</b></span>
                  <span>● Others <b>10%</b></span>
                </div>

              </div>
            </div>

            {/* PRICE */}
            <div className="chart-box">
              <h4>Asking Price Range</h4>

              <div className="bar-chart">

                <div className="bar-item">
                  <div
                    className="bar"
                    style={{ height: "35%" }}
                  ></div>
                  <span>&lt; £500K</span>
                </div>

                <div className="bar-item">
                  <div
                    className="bar"
                    style={{ height: "55%" }}
                  ></div>
                  <span>£500K–£1M</span>
                </div>

                <div className="bar-item">
                  <div
                    className="bar"
                    style={{ height: "85%" }}
                  ></div>
                  <span>£1M–£2M</span>
                </div>

                <div className="bar-item">
                  <div
                    className="bar"
                    style={{ height: "58%" }}
                  ></div>
                  <span>£2M+</span>
                </div>

              </div>
            </div>

            {/* PIPELINE */}
            <div className="chart-box">
              <h4>Sale Pipeline</h4>

              <div className="pipeline">

                <div className="pipeline-donut">
                  <strong>14</strong>
                  <span>Total</span>
                </div>

                <div className="pipeline-labels">
                  <span>● Initial Enquiry <b>5</b></span>
                  <span>● Valuation <b>4</b></span>
                  <span>● Due Diligence <b>3</b></span>
                  <span>● Negotiation <b>2</b></span>
                </div>

              </div>
            </div>

          </div>

          {/* RECENT LISTINGS */}
          <div className="recent-listings">

            <h4>Recent Listings</h4>

            <div className="listing-table">

              <div className="table-row table-heading">
                <span>Property Name</span>
                <span>Location</span>
                <span>Type</span>
                <span>Beds</span>
                <span>Asking Price</span>
                <span>Status</span>
              </div>

              <div className="table-row">
                <span>Greenfield Care Home</span>
                <span>Surrey</span>
                <span>Residential</span>
                <span>45</span>
                <span>£1,850,000</span>
                <span className="status green">
                  For Sale
                </span>
              </div>

              <div className="table-row">
                <span>Meadow View Care Home</span>
                <span>Manchester</span>
                <span>Nursing</span>
                <span>38</span>
                <span>£1,250,000</span>
                <span className="status orange">
                  Under Offer
                </span>
              </div>

              <div className="table-row">
                <span>Riverside Care Home</span>
                <span>Birmingham</span>
                <span>Residential</span>
                <span>30</span>
                <span>£950,000</span>
                <span className="status green">
                  For Sale
                </span>
              </div>

              <div className="table-row">
                <span>Woodlands Care Home</span>
                <span>Leeds</span>
                <span>Nursing</span>
                <span>42</span>
                <span>£1,650,000</span>
                <span className="status blue">
                  Due Diligence
                </span>
              </div>

            </div>
          </div>

        </div>
      </main>

      {/* =====================================================
          BUY / SELL SELECTOR
      ====================================================== */}

      <section className="buy-sell-section">

        <div className="section-heading">

          <span>WHAT ARE YOU LOOKING TO DO?</span>

          <h2>
            Care home sales handled properly.
          </h2>

          <p>
            Whether you're looking to acquire your next care
            business or sell an existing operation, our specialist
            team  <br />can support you from the first conversation
            through to completion.
          </p>

        </div>


        <div className="buy-sell-tabs">

          <button
            className={activeTab === "buy" ? "active" : ""}
            onClick={() => setActiveTab("buy")}
          >
            <span>01</span>
            I want to buy a care home
          </button>

          <button
            className={activeTab === "sell" ? "active" : ""}
            onClick={() => setActiveTab("sell")}
          >
            <span>02</span>
            I want to sell a care home
          </button>

        </div>


        {/* BUY SECTION */}

        {activeTab === "buy" && (

          <div className="buy-content">

            <div className="buy-content-text">

              <span className="small-label">
                BUY A CARE HOME
              </span>

              <h3>
                Find the right care
                <br />
                business for your goals.
              </h3>

              <p>
                Finding the right care home is about more than
                location and price. We help buyers understand
                the opportunity, assess the business and navigate
                the acquisition process.
              </p>

              <ul>
                <li>Access suitable care home opportunities</li>
                <li>Understand financial and operational performance</li>
                <li>Support with valuation and negotiations</li>
                <li>Assistance through due diligence</li>
                <li>End-to-end transaction support</li>
              </ul>

              <button
                className="primary"
                onClick={() => navigate("/")}
              >
                Discuss Your Requirements
              </button>

            </div>


            <div className="buy-card">

              <div className="buy-card-top">
                <span>AVAILABLE OPPORTUNITIES</span>
                <strong>28</strong>
              </div>

              <div className="opportunity-item">

                <div>
                  <h4>Greenfield Care Home</h4>
                  <p>Surrey · 45 Beds</p>
                </div>

                <strong>£1.85M</strong>

              </div>

              <div className="opportunity-item">

                <div>
                  <h4>Riverside Care Home</h4>
                  <p>Birmingham · 30 Beds</p>
                </div>

                <strong>£950K</strong>

              </div>

              <div className="opportunity-item">

                <div>
                  <h4>Woodlands Care Home</h4>
                  <p>Leeds · 42 Beds</p>
                </div>

                <strong>£1.65M</strong>

              </div>
            </div>

          </div>

        )}


        {/* SELL SECTION */}

        {activeTab === "sell" && (

          <div className="sell-content">

            <div className="sell-visual">

              <div className="valuation-card">

                <span>ESTIMATED MARKET VALUE</span>

                <strong>£1.42M</strong>

                <small>
                  Indicative valuation based on current
                  market conditions
                </small>

                <div className="valuation-line">
                  <span></span>
                </div>

                <div className="valuation-footer">
                  <span>Occupancy</span>
                  <b>91%</b>
                </div>

                <div className="valuation-footer">
                  <span>Annual Revenue</span>
                  <b>£2.8M</b>
                </div>

                <div className="valuation-footer">
                  <span>EBITDA</span>
                  <b>£620K</b>
                </div>

              </div>

            </div>


            <div className="sell-content-text">

              <span className="small-label">
                SELL YOUR CARE HOME
              </span>

              <h3>
                Get the right value
                <br />
                for your care business.
              </h3>

              <p>
                Selling a care home is a major decision. Our
                experienced team helps you understand your
                property's market position, prepare the
                opportunity and identify suitable buyers.
              </p>

              <ul>
                <li>Confidential initial valuation</li>
                <li>Market positioning and preparation</li>
                <li>Targeted buyer introductions</li>
                <li>Offer management and negotiation</li>
                <li>Support through completion</li>
              </ul>

              <button
                className="primary"
                onClick={() => navigate("/contact")}
              >
                Request a Confidential Valuation
              </button>

            </div>

          </div>

        )}

      </section>


      {/* =====================================================
          WHY CHOOSE US
      ====================================================== */}

      <section className="why-sales-section">

        <div className="section-heading centered">

          <span>WHY TOTAL CARE ADVISORY?</span>

          <h2>More than a transaction. A specialist partner.</h2>

          <p>
            Our understanding of the care sector means we look
            beyond the property to understand the business, <br />
            operations and opportunities behind every transaction.
          </p>

        </div>


        <div className="why-sales-grid">

          <div className="why-card">

            <div className="why-number">
              01
            </div>

            <h3>
              Care Sector Expertise
            </h3>

            <p>
              Specialist knowledge of care homes, operators,
              regulation and the commercial realities of the
              sector.
            </p>

          </div>


          <div className="why-card">

            <div className="why-number">
              02
            </div>

            <h3>
              Confidential Approach
            </h3>

            <p>
              We understand the importance of protecting your
              business, staff and reputation during a sale.
            </p>

          </div>


          <div className="why-card">

            <div className="why-number">
              03
            </div>

            <h3>
              Commercial Focus
            </h3>

            <p>
              We focus on achieving the right commercial result,
              not simply completing a transaction.
            </p>

          </div>


          <div className="why-card">

            <div className="why-number">
              04
            </div>

            <h3>
              End-to-End Support
            </h3>

            <p>
              From the initial valuation through negotiation,
              due diligence and completion, we're with you.
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          SALES PROCESS
      ====================================================== */}

      <section className="sales-process-section">
        <div className="section-heading">
          <span>OUR PROCESS</span>
          <h2>A clear route from enquiry to completion.</h2>
          <p>
            We keep the process structured, transparent and
            focused on your objectives.
          </p>
        </div>
        <div className="process-grid">

          {salesProcess.map((item) => (

            <div className="process-card" key={item.number}>

              <span className="process-number">
                {item.number}
              </span>

              <h3>
                {item.title}
              </h3>

              <p>
                {item.text}
              </p>

            </div>

          ))}

        </div>

      </section>


      {/* =====================================================
          FEATURED PROPERTIES
      ====================================================== */}

      <section className="properties-section">

        <div className="properties-heading">

          <div>

            <span>
              FEATURED OPPORTUNITIES
            </span>

            <h2>Care homes currently <br />available.</h2>

          </div>
        </div>

        <div className="property-grid">
          {properties.map((property, index) => (
            <article
              className="property-card"
              key={property.title}
            >
              <div className="property-image">
                <img
                  src={property.image}
                  alt={property.title}
                />

                <span className="property-status">
                  {property.status}
                </span>
              </div>

              <div className="property-content">
                <div className="property-top">
                  <div>
                    <h3>
                      {property.title}
                    </h3>
                    <p>
                      {property.location}
                    </p>
                  </div>
                  <strong>
                    {property.price}
                  </strong>
                </div>
                <div className="property-details">
                  <span>
                    {property.type}
                  </span>
                  <span>
                    {property.beds}
                  </span>
                </div>
                <button>
                  View Opportunity →
                </button>
              </div>
            </article>
          ))}
        </div>
      </section>


      {/* =====================================================
          STATS
      ====================================================== */}

      <section className="sales-stats">

        <div className="sales-stat-item">

          <strong>
            100+
          </strong>

          <span>
            Care businesses supported
          </span>

        </div>

        <div className="sales-stat-item">

          <strong>
            £50M+
          </strong>

          <span>
            Transaction value supported
          </span>

        </div>

        <div className="sales-stat-item">

          <strong>
            15+
          </strong>

          <span>
            Years of sector experience
          </span>

        </div>

        <div className="sales-stat-item">

          <strong>
            UK
          </strong>

          <span>
            Specialist care sector coverage
          </span>

        </div>

      </section>


      {/* =====================================================
          FAQ
      ====================================================== */}

      <section className="sales-faq-section">

        <div className="section-heading centered">

          <span>QUESTIONS</span>

          <h2>
            Care home sales FAQs.
          </h2>

          <p>
            Some of the questions we're most commonly asked
            by buyers and sellers.
          </p>

        </div>


        <div className="faq-list">

          {faqs.map((faq) => (

            <details key={faq.question}>

              <summary>
                {faq.question}

                <span>
                  +
                </span>
              </summary>

              <p>
                {faq.answer}
              </p>

            </details>

          ))}

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ====================================================== */}

      <section className="sales-final-cta">

        <div>

          <span>
            READY TO TAKE THE NEXT STEP?
          </span>

          <h2>Let's talk about your care home.</h2>

          <p>
            Whether you're considering selling, looking to
            acquire a care business or simply want to understand
            your options, our team is here to help.
          </p>

          <div className="final-cta-buttons">

            <button
              onClick={() => navigate("/contact")}
              className="cta-white"
            >
              Book a Free Consultation
            </button>

            <button
              onClick={() => navigate("/contact")}
              className="cta-outline"
            >
              Request a Valuation
            </button>

          </div>

        </div>

      </section>
    </div>
  );
};

export default Care_Sale;